import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Card, Button, Row, Col, Spin, Space, Typography } from 'antd';
import { EditOutlined } from '@ant-design/icons';
import axios from 'axios';
import { useDispatch, useSelector } from 'react-redux';
import { setMessage } from '../../../redux/message.reducer';
import { isAdmin } from '../../../utils/userRoles';
import CommentAttachments from '../../../components/CommentAttachments/CommentAttachments';
import '../../order/edit/OrderEdit.css';
import '../../order/view/OrderView.css';

export default function EncyclopediaView() {
  const { id } = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { user } = useSelector((state) => state.authReducer);
  const [entry, setEntry] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!id) {
      setLoading(false);
      return;
    }
    let cancelled = false;
    axios
      .get(`/encyclopedia/${id}`)
      .then((res) => {
        if (!cancelled) setEntry(res.data);
      })
      .catch((err) => {
        if (!cancelled) {
          const msg = err.response?.data?.error || 'Failed to load entry';
          dispatch(setMessage({ message: msg, type: 'error' }));
          navigate('/encyclopedia');
        }
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });
    return () => {
      cancelled = true;
    };
  }, [id, navigate, dispatch]);

  if (loading) {
    return (
      <div className="order-edit-page order-view-page">
        <div className="order-edit-loading">
          <Spin size="large" />
        </div>
      </div>
    );
  }

  if (!entry) return null;

  const attachments = Array.isArray(entry.attachments) ? entry.attachments : [];

  return (
    <div className="order-edit-page order-view-page">
      <Space direction="vertical" size="large" style={{ width: '100%' }}>
        <div
          className="order-view-header"
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'flex-start',
            flexWrap: 'wrap',
            gap: 12,
          }}
        >
          <div className="order-view-header-title-wrap">
            <Typography.Title level={3} className="order-view-title">
              {entry.name || 'Encyclopedia'}
            </Typography.Title>
          </div>
        </div>

        <Card className="order-view-card order-view-card-details">
          <div className="order-view-card-head">
            <Typography.Title level={5} className="order-view-section-title">
              Details
            </Typography.Title>
          </div>
          <Row gutter={[24, 20]}>
            <Col xs={24}>
              <div className="order-view-field">
                <span className="order-view-label">Name</span>
                <span className="order-view-value">{entry.name ?? '—'}</span>
              </div>
            </Col>
            <Col xs={24}>
              <div className="order-view-field">
                <span className="order-view-label">Description</span>
                <span className="order-view-value" style={{ whiteSpace: 'pre-wrap' }}>
                  {entry.description ?? '—'}
                </span>
              </div>
            </Col>
            {attachments.length > 0 && (
              <Col xs={24}>
                <div className="order-view-field">
                  <span className="order-view-label">Attachments</span>
                  <CommentAttachments attachments={attachments} className="order-edit-chat-bubble-attachments" />
                </div>
              </Col>
            )}
          </Row>
        </Card>
      </Space>
    </div>
  );
}
